export default __webpack_public_path__ + "static/media/home-raket.313ce8d7.svg";